var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMovieDownloadedIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.033,
    height: 19.033,
    viewBox: "0 0 19.033 19.033",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "check_circle_FILL1_wght700_GRAD0_opsz48",
    d: "M10.891,13.682,9.124,11.915a.973.973,0,0,0-.716-.291,1.049,1.049,0,0,0-.738.291,1.085,1.085,0,0,0-.313.76.973.973,0,0,0,.291.716l2.5,2.5a.986.986,0,0,0,.727.291,1.063,1.063,0,0,0,.749-.291l5.122-5.144a.959.959,0,0,0,.291-.7,1.072,1.072,0,0,0-.313-.749,1.049,1.049,0,0,0-.738-.291,1.085,1.085,0,0,0-.76.313Zm1.387,8.052a9.729,9.729,0,0,1-3.78-.727,9.119,9.119,0,0,1-5.021-5.021,9.729,9.729,0,0,1-.727-3.78,9.531,9.531,0,0,1,.727-3.724,9.409,9.409,0,0,1,2-3.019A9.307,9.307,0,0,1,8.5,3.438a9.6,9.6,0,0,1,3.78-.738,9.442,9.442,0,0,1,9.505,9.528,9.543,9.543,0,0,1-.738,3.757A9.307,9.307,0,0,1,19.021,19a9.409,9.409,0,0,1-3.019,2A9.531,9.531,0,0,1,12.278,21.733Z",
    transform: "translate(-2.75 -2.7)",
    fill: "#52b35d"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMovieDownloadedIcon);
export default __webpack_public_path__ + "static/media/MovieDownloadedIcon.87dc31830bf4a74fc7cd7a50ed2d0c14.svg";
export { ForwardRef as ReactComponent };